module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-US":{"title":"Compare Listings","cta":{"compare":"Compare","clear":"Clear"}},"es-MX":{"title":"Comparar Propiedades","cta":{"compare":"Comparar","clear":"Borrar"}}}')
  delete Component.options._Ctor
}
